import { render, staticRenderFns } from "./qzzx-card.vue?vue&type=template&id=58098da0&scoped=true&"
import script from "./qzzx-card.vue?vue&type=script&lang=js&"
export * from "./qzzx-card.vue?vue&type=script&lang=js&"
import style0 from "./qzzx-card.vue?vue&type=style&index=0&id=58098da0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58098da0",
  null
  
)

export default component.exports